import { render, staticRenderFns } from "./WDateRange.vue?vue&type=template&id=35b563dc&"
import script from "./WDateRange.vue?vue&type=script&lang=js&"
export * from "./WDateRange.vue?vue&type=script&lang=js&"
import style0 from "./WDateRange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports